<template>
  <div class="layout-container skinc-container2">
    <TopSection />
    <BottomCards />
  </div>
</template>

<script>
import TopSection from './TopSection.vue';
import BottomCards from './BottomCards.vue';

export default {
  name: 'LayoutContainer',
  components: {
    TopSection,
    BottomCards
  }
};
</script>

<style scoped>
.layout-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f9f9f9;
  padding-top: 10vh;
  box-sizing: border-box;
}
</style>
